// extracted by mini-css-extract-plugin
export default {"CompanyTopicItem":"company-topic-item_CompanyTopicItem__zqcMs","keywords":"company-topic-item_keywords__s3LTx","labelText":"company-topic-item_labelText__Eh5pd"};